import React, {useState, useEffect} from "react"
import {contact_server} from "../trialSteps/contact-server"

const OrderCharge = props => {
    const {
        databaseData, 
        nextStep,
        onError,
        setDatabaseData,              
        serverUrl,
    } = props;
    let [contactingServer, setContactingServer] = useState(false)

    useEffect( ()=>{
        contact_server ({
            databaseData,
            setDatabaseData,
            nextStep,
            onError,
            url: `${serverUrl}/cart/order_charge`,
        });
        setContactingServer(true);
    // eslint-disable-next-line    
    },[]);
    if (contactingServer)
        return <h2>Checking Payment</h2>
    return <h2> Processing Payment </h2>
}

export default OrderCharge